















































import { defineComponent, ref } from '@vue/composition-api';
import { RowTypes } from '@oare/types';

export default defineComponent({
  props: {
    hasAddedRow: {
      type: Boolean,
      required: true,
    },
    showDivider: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const insertOptions = ref<RowTypes[]>([
      'Line',
      'Broken Line(s)',
      'Ruling(s)',
      'Seal Impression',
      'Broken Area',
      'Uninscribed Line(s)',
    ]);
    return {
      insertOptions,
    };
  },
});
